(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-pdp-editorial"] && !Shopify.designMode) return;
  try {
    
  const initialiseStyleCarousels = (root = document) => {
    root.querySelectorAll('[data-ll-style-carousel]').forEach((section) => {
      if (section.dataset.carouselReady === 'true') return;

      const track = section.querySelector('[data-carousel-track]');
      const slides = Array.from(section.querySelectorAll('[data-carousel-slide]'));
      const previousButton = section.querySelector('[data-carousel-prev]');
      const nextButton = section.querySelector('[data-carousel-next]');
      const currentLabel = section.querySelector('[data-carousel-current]');
      const totalLabel = section.querySelector('[data-carousel-total]');

      if (!track || slides.length === 0 || !previousButton || !nextButton) return;

      section.dataset.carouselReady = 'true';
      if (totalLabel) totalLabel.textContent = slides.length;

      const currentIndex = () => {
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const updateControls = () => {
        const index = currentIndex();
        if (currentLabel) currentLabel.textContent = index + 1;
        previousButton.disabled = index === 0;
        nextButton.disabled = index === slides.length - 1;
      };

      const goToSlide = (index) => {
        const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => goToSlide(currentIndex() - 1));
      nextButton.addEventListener('click', () => goToSlide(currentIndex() + 1));
      track.addEventListener('scroll', updateControls, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToSlide(currentIndex() - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToSlide(currentIndex() + 1);
        }
      });

      updateControls();
    });
  };

  initialiseStyleCarousels();

  new MutationObserver(() => initialiseStyleCarousels()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', (event) => initialiseStyleCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-tableware-hub"] && !Shopify.designMode) return;
  try {
    
if(!window.llTablewareHubScroll){window.llTablewareHubScroll=true;document.addEventListener('click',function(event){const button=event.target.closest('[data-lltw-hub] button[data-scroll-target]');if(!button)return;const target=document.getElementById(button.dataset.scrollTarget);if(target){target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-upholstery-editor"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.llUpholsteryInstalled) return;
  window.llUpholsteryInstalled = true;
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollToElement = (element) => {
    if (!element) return;
    element.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    if (element.matches('[tabindex]')) element.focus({ preventScroll: true });
  };
  const mainForPage = () => document.querySelector('[data-ll-up-main]') || document.querySelector('.shopify-section--main-product');
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button, a');
    if (!button || !button.closest('.ll-up, [data-ll-up-guide-link]')) return;
    if (button.dataset.scrollTarget) scrollToElement(document.getElementById(button.dataset.scrollTarget));
    if (button.hasAttribute('data-ll-up-fit-jump')) scrollToElement(document.querySelector('[data-ll-up-fit]'));
    if (button.hasAttribute('data-ll-up-guide-open')) {
      const launcher = mainForPage()?.querySelector('[data-size-guide-open]');
      if (launcher) launcher.click();
      else scrollToElement(mainForPage()?.querySelector('.ll-up-purchase'));
    }
    if (button.hasAttribute('data-ll-up-samples-open')) {
      const launcher = mainForPage()?.querySelector('[data-ll-fabric-samples] > button[aria-controls]');
      if (launcher) { event.preventDefault(); launcher.click(); }
    }
    if (button.dataset.llUpDialogOpen) {
      const dialog = document.getElementById(button.dataset.llUpDialogOpen);
      if (dialog instanceof HTMLDialogElement && !dialog.open) {
        dialog.llReturnFocus = button;
        dialog.showModal();
      }
    }
    if (button.hasAttribute('data-ll-up-dialog-close')) button.closest('dialog')?.close();
  });
  const initializeDialogs = (scope) => {
    scope.querySelectorAll('.ll-up-dialog').forEach((dialog) => {
      if (dialog.dataset.llReady) return;
      dialog.dataset.llReady = 'true';
      dialog.addEventListener('close', () => dialog.llReturnFocus?.focus());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  };
  initializeDialogs(document);
  document.addEventListener('shopify:section:load', (event) => initializeDialogs(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.closest('.ll-up-story')) scrollToElement(event.target);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["styling-guide-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ll-guide-youtube')) {
    customElements.define('ll-guide-youtube', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        this.abortController = new AbortController();
        this.player = this.querySelector('[data-player]');
        this.playButton = this.querySelector('[data-play]');
        this.modal = this.closest('x-modal');
        this.videoId = this.getVideoId(this.dataset.url);
        if (!this.videoId || !this.player || !this.playButton || !this.modal) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.querySelector('[data-youtube-fallback]').href = `https://www.youtube.com/watch?v=${this.videoId}`;
        this.playButton.addEventListener('click', () => this.loadVideo(), { signal: this.abortController.signal });
        this.observer = new MutationObserver(() => {
          if (!this.modal.hasAttribute('open')) this.resetVideo();
        });
        this.observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        this.resetVideo();
      }
      getVideoId(value) {
        try {
          const url = new URL(value);
          if (!['https:', 'http:'].includes(url.protocol)) return null;
          const host = url.hostname.toLowerCase();
          const parts = url.pathname.split('/').filter(Boolean);
          let id = null;
          if (host === 'youtu.be' || host === 'www.youtu.be') {
            id = parts[0];
          } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].includes(host)) {
            if (parts[0] === 'watch') id = url.searchParams.get('v');
            if (['embed', 'shorts', 'live'].includes(parts[0])) id = parts[1];
          }
          return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : null;
        } catch {
          return null;
        }
      }
      loadVideo() {
        if (this.player.querySelector('iframe') || !this.modal.hasAttribute('open')) return;
        const iframe = document.createElement('iframe');
        iframe.title = this.dataset.title;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=1&playsinline=1&rel=0`;
        this.playButton.hidden = true;
        this.player.appendChild(iframe);
        iframe.focus();
      }
      resetVideo() {
        this.player?.querySelector('iframe')?.remove();
        if (this.playButton) this.playButton.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
